/* eslint-disable react/prop-types */
import React from 'react';
import LoadingIcon from 'mdi-react/LoadingIcon';

interface Props {
  loading: boolean;
}

const Spinner: React.FC<Props> = ({ loading = false }) =>
  loading && (
    <div className="panel__refresh">
      <LoadingIcon />
    </div>
  );

export default React.memo(
  Spinner,
  (prevProps, nextProps) => prevProps.loading === nextProps.loading
);
